module.exports = __webpack_public_path__ + "static/img/culture-vision.23a3bd4f.png";